// sector.ts duplicated from deprecated area.ts for new imports
import { Sector } from "models"
import * as filterEnum from "enums/filterEnum"
import { RESS } from "lib/util/constants"

export const Text = filterEnum.Text<"sector", Sector>
export const Dropdown = filterEnum.Dropdown<"sector", Sector>

export const SectorSearchField = () =>
	Dropdown({
		field: "sector",
		getter: async ({ api }) => {
			const sectors = await api().ContainmentSectors()
			return sectors.Sort((a, b) => {
				const aIsRess = a.name?.toUpperCase() === RESS
				const bIsRess = b.name?.toUpperCase() === RESS
				if (aIsRess && !bIsRess) return -1
				if (!aIsRess && bIsRess) return 1
				return a.name.localeCompare(b.name)
			})
		},
		label: "Sectors",
	})

export const SectorByContainmentTypeField = (typeName: string) =>
	Dropdown({
		field: "sector",
		getter: async ({ api }) => {
			if (!typeName) return []
			const sectors = await api().SectorsByContainmentType(typeName)
			return sectors.Sort((a, b) => {
				const aIsRess = a.name?.toUpperCase() === RESS
				const bIsRess = b.name?.toUpperCase() === RESS
				if (aIsRess && !bIsRess) return -1
				if (!aIsRess && bIsRess) return 1
				return a.name.localeCompare(b.name)
			})
		},
		label: "Sectors",
	})